import { render } from "./ColorScheme.vue?vue&type=template&id=48b06b3b&scoped=true&ts=true"
import script from "./ColorScheme.vue?vue&type=script&lang=ts"
export * from "./ColorScheme.vue?vue&type=script&lang=ts"

import "./ColorScheme.vue?vue&type=style&index=0&id=48b06b3b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b06b3b"]])

export default __exports__